import { Controller } from '@hotwired/stimulus';
import * as bootstrap from 'bootstrap';

// Initializes Bootstrap ScrollSpy on the document body,
// targeting the nav element this controller is attached to.
//
// Bootstrap only toggles the .active class, which says nothing to a screen
// reader. The activate event is mirrored onto aria-current, whose "location"
// token is the one for a position inside the page.
//
// Usage:
//   <nav data-controller="scrollspy-nav">
//     <a href="#section1">Section 1</a>
//   </nav>
export default class extends Controller {
  connect() {
    this.onActivate = (event) => this.markCurrent(event.relatedTarget);

    document.body.addEventListener('activate.bs.scrollspy', this.onActivate);

    this.scrollspy = new bootstrap.ScrollSpy(document.body, {
      target: this.element,
      offset: this.element.offsetHeight + 20,
      smoothScroll: true,
    });

    this.markCurrent(this.element.querySelector('.active'));
  }

  disconnect() {
    document.body.removeEventListener('activate.bs.scrollspy', this.onActivate);
    this.scrollspy?.dispose();
  }

  markCurrent(link) {
    this.links.forEach((other) => {
      if (other === link) {
        other.setAttribute('aria-current', 'location');
      } else {
        other.removeAttribute('aria-current');
      }
    });
  }

  get links() {
    return Array.from(this.element.querySelectorAll('a[href^="#"]'));
  }
}
